<template>
  <v-list
    :heading="$t('solutionList.heading')"
    item-component="v-card-solution"
    :items="items"
  />
</template>
<script>
import VList from "../components/vList";
import apiMixin from "../mixins/apiMixin.js";
import transformers from "../transformers/transformers";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "VSolutions",
  components: {
    VList
  },
  mixins: [
    apiMixin.apiMixin,
    transformers.solutionCardTransformer,
  ],
  data: () => ({
    items: [],
    loaded: false
  }),
  computed: {
    ...mapGetters([
      'getCustomerCar',
      'getCustomer',
      'getCurrentSolution',
      'getHttp'
    ]),
    hasAddonProducts() {

      let connector = this.getCustomer.carModel.connector.toLowerCase().replace(/ /g, '');
      return this.getCurrentSolution.addonProducts[connector].length ? true : false;
    },
  },

  methods: {
    ...mapActions([
        'setSolution',
      ]
    ),

    pushResponse(response, car) {
      this.items = [];
      var response = response.data.data;

      for (var index in response) {
        this.items.push(this.transformItem(response[index], car));
      }
      this.loaded = true;
    },

    transformItem(item, car) {
      var that = this;
      var trafo = this.solutionCardTransform(item, car);

      trafo.buttonLabelDefault = this.$t('solutionList.button.label'),
        trafo.onClick = function () {
          that.setSolution(item);

          if (that.hasAddonProducts) {
            that.$router.push("/orders/new/accessories");
          } else {
            that.$router.push("/orders/new");
          }
        };

      return trafo;

    }
  },

  mounted: function () {
    var that = this;
    const http = this.getHttp;
    let config = this.apiHeaders;
    var car = this.getCustomerCar;

    config.params = {};
    if (car.slug) {
      config.params["carModel"] = car.slug;
    }
    config.params["autoLimitEffect"] = false;

    // get cached version if it exists
    http.get(process.env.VUE_APP_API_URL + "/solutions", config).then(function (response) {
      that.pushResponse(response, car);
    });

    // do real request, unless throttled because of first request
    config.forceUpdate = true;
    http.get(process.env.VUE_APP_API_URL + "/solutions", config).then(function (response) {
      that.pushResponse(response, car);
    });
  }
};
</script>

<style scoped>

</style>
